export default __webpack_public_path__ + "static/media/13.2b89178f.png";